import React from 'react';
import classnames from 'classnames';
import DependencyManager from "../../DependencyManager";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { compose } from 'redux';
import withConfig from "../../ComponentDependency/withConfig";
import UserSession from "../../Utils/UserSession";
import { EXPONEA_EVENT_TYPES, EXPONEA_USER_FLOW } from "../../Constants/exponeaLeads";
var css = {
  "wrapper": "oalp-3iX1n",
  "userDetailsForm": "oalp-374uT",
  "userDetailsForm__heading": "oalp-3IIQJ",
  "userDetailsForm__closeBtn": "oalp-2wOjs",
  "userDetailsForm__fields": "oalp-OXddm",
  "nameField": "oalp-2LZt1",
  "phoneField": "oalp-3O0YS",
  "emailField": "oalp-1IGBD",
  "userDetailsForm__additionalInfo": "oalp-NhRDI",
  "userDetailsForm__disclaimer": "oalp-3ujMO",
  "userDetailsForm__submitBtn": "oalp-3X7o3",
  "imp": "oalp-3zQWQ",
  "userDetailsForm__tncCheckbox": "oalp-2yIu8",
  "userDetailsForm__tncCheckbox__label": "oalp-1sOBs",
  "userDetailsForm__wrapperDiv": "oalp-1u6-r",
  "mobile": "oalp-SuF7l",
  "userDetailsForm__tncCheckboxbg": "oalp-3KcR1",
  "thankYou": "oalp-4gfsV",
  "img": "oalp-32JvA",
  "textWrapper": "oalp-1_7HO"
};
import { TAB_NAME } from "../../Constants/evaluation";
import { HP_OLX_TRACKING } from "../../Constants/hptracking";
import TitleComponent from "../../Components/Title/Title";
export var LeadGenForm = function LeadGenForm(_ref) {
  var metadata = _ref.metadata,
    UserDetailsFormWidget = _ref.UserDetailsFormWidget,
    config = _ref.config,
    track = _ref.track;
  var style = metadata.style,
    title = metadata.title,
    thankYouTitle = metadata.thankYouTitle,
    thankYouSubtitle = metadata.thankYouSubtitle;
  var PanameraConstants = DependencyManager.getDependency('constants');
  if (typeof UserDetailsFormWidget !== 'function') {
    return null;
  }
  function getHpLandingName() {
    return UserSession.getTabName() === TAB_NAME.BUY ? HP_OLX_TRACKING.HP_CF_BUY : '';
  }
  function getSubHeading() {
    if (typeof title === 'string') {
      return title;
    }
    return /*#__PURE__*/React.createElement(TitleComponent, {
      title: title
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.wrapper, css[PanameraConstants.platform]),
    style: style
  }, /*#__PURE__*/React.createElement(UserDetailsFormWidget, {
    config: config,
    css: css,
    showSubHeading: true,
    subHeading: getSubHeading(),
    showTAndC: false,
    thankYouTitle: thankYouTitle,
    userFlow: EXPONEA_USER_FLOW.B2C,
    track: track,
    hp_tracking_event: getHpLandingName(),
    eventType: UserSession.getTabName() === TAB_NAME.BUY ? EXPONEA_EVENT_TYPES.CF_SUBMIT : EXPONEA_EVENT_TYPES.INTERESTED_SUBMIT,
    thankYouSubtitle: thankYouSubtitle
  }));
};
export default compose(withComponentDependency, withConfig)(LeadGenForm);